var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.443 11.4482V14.4117C16.443 14.8047 16.2869 15.1816 16.009 15.4594C15.7311 15.7373 15.3542 15.8934 14.9612 15.8934H4.58915C4.19617 15.8934 3.81929 15.7373 3.54141 15.4594C3.26353 15.1816 3.10742 14.8047 3.10742 14.4117V11.4482",
    stroke: "#0F0C22",
    strokeWidth: 1.48173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.479 6.26291L9.77463 2.55859L6.07031 6.26291",
    stroke: "#0F0C22",
    strokeWidth: 1.48173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77539 2.55859V11.449",
    stroke: "#0F0C22",
    strokeWidth: 1.48173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bea47ef4527df81137d8cdb873b11953.svg";
export { ForwardRef as ReactComponent };